import styled from 'styled-components';

export const StyledStats = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StatsContainerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
`;

export const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 300px;
    margin: 30px;
`;

export const StatsNumber = styled.p`
    font-size: 100px;
    font-family: BlenderProBold, serif;   
    margin: 0; 
    height: 150px;
    line-height: 150px;
`;

export const StatsDesc = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: ${({color}) => color};
    letter-spacing: 2px;
`;

export const StatsText = styled.p`
    font-family: Roboto Condensed, serif;
    font-size: 13px;
    font-weight: 300;
    letter-spacing: 1px;
    text-align: center;
    line-height: 1.2;
`;

export const StatsQuote = styled.p`
    font-family: BlenderProBold, serif;
    font-size: 17px;
    letter-spacing: 1px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
`;
